module.exports = __webpack_public_path__ + "img/caret.64ae15cf.svg";